import React from "react";
import { Button } from "../core/Button.jsx";
import { Card } from "../core/Card.jsx";
import { Loader } from "../feedback/Loader.jsx";
import "./ListItem.css";

/* Settings / profile list row — replaces legacy uiComponents ListItem. */
export function ListItem({
  name,
  value,
  buttonAction,
  buttonText = "Change",
  buttonVariant = "outline",
  buttonSize = "lg",
  buttonDisabled,
  buttonHidden,
  loader,
  rightContent,
  testIds,
  content,
  labelWidth = 160,
  surface = "card",
  style,
  className = "",
  ...rest
}) {
  const middle =
    content != null
      ? typeof content === "string"
        ? <strong className="tk-list-item__content">{content}</strong>
        : content
      : value == null || value === ""
        ? null
        : typeof value === "string"
          ? <span className="tk-list-item__value">{value}</span>
          : value;

  const hasAction = !buttonHidden;
  const itemClassName = `tk-list-item${surface === "flat" ? " tk-list-item--flat" : ""} ${className}`.trim();
  const itemStyle = {
    "--tk-list-item-label-width": `${labelWidth}px`,
    ...(surface === "card" ? { padding: "24px", marginBottom: 24 } : {}),
    ...style,
  };

  const row = (
    <>
      <strong data-testid={testIds?.name} className="tk-list-item__label">
        {name}
      </strong>
      <div className="tk-list-item__middle">{middle}</div>
      {hasAction ? (
        <div className="tk-list-item__action">
          {rightContent || (
            <Button
              size={buttonSize}
              variant={buttonVariant}
              onClick={buttonAction}
              disabled={buttonDisabled || loader}
              data-testid={testIds?.button}
              style={{ minWidth: buttonVariant === "ghost" ? 0 : 100 }}
            >
              {loader ? <Loader variant="inline" size={18} label="Loading" /> : buttonText}
            </Button>
          )}
        </div>
      ) : null}
    </>
  );

  if (surface === "flat") {
    return (
      <div
        className={itemClassName}
        data-has-action={hasAction ? "true" : undefined}
        style={itemStyle}
        {...rest}
      >
        {row}
      </div>
    );
  }

  return (
    <Card className={itemClassName} data-has-action={hasAction ? "true" : undefined} style={itemStyle} {...rest}>
      {row}
    </Card>
  );
}

export default ListItem;
